/**
 * Ask Iris in help mode (CU-869fmufdb, plan § 2.4): which help page the screen on display has, from the generated
 * map (`screens.js`, written by the kit's `company/tools/help_bundle.py`).
 *
 * Exact match on the path (a trailing slash is ignored): only the 38 screens with a page get the header icon (UX
 * C1); Admin, Pricing Tool, the "Moved" notes and sub-paths do not. The name in the question is the page title, plus
 * the open tab's when that tab has its own page (UX C2, C3: "Setup › Price limits"); a repricing pass on DOR/LOR
 * never changes it. The hint is what the button sends on its turn — ids only; webback turns it into the pages.
 *
 * Pure and alias-free (TL R4).
 */
import { HELP_SCREENS } from './screens.js'

export const TAB_SEPARATOR = ' › '
export const PASS_VIEW = 'repricing-pass'

export function normalizePath(pathname) {
	if (typeof pathname !== 'string' || !pathname) return ''
	const trimmed = pathname.replace(/\/+$/, '')
	return trimmed || '/'
}

/** `{ id, name, hint }` for the screen at `pathname`, or null when it has no help page. */
export function screenHelpFor(pathname, { tab = null, pass = null } = {}, screens = HELP_SCREENS) {
	const entry = screens[normalizePath(pathname)]
	if (!entry) return null
	const tabTitle = tab ? entry.tabs?.[tab] : null
	const view = pass && (entry.views || []).includes(PASS_VIEW) ? PASS_VIEW : null
	return {
		id: entry.id,
		name: tabTitle ? `${entry.title}${TAB_SEPARATOR}${tabTitle}` : entry.title,
		hint: { screen: entry.id, tab: tab || null, view },
	}
}
